import React from 'react';
import { saasProducts } from '../data/mock';
import { ArrowUpRight } from 'lucide-react';

const SaasSection = () => {
  return (
    <section className="bg-[#0a0a0b] py-16 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          {/* Left Content */}
          <div>
            <span className="text-gray-500 text-sm block mb-1">Our SaaS</span>
            <h2 className="text-2xl md:text-3xl text-white font-normal">
              SaaS Solutions
            </h2>
          </div>

          {/* Products */}
          <div className="flex gap-4">
            {saasProducts.map((product) => (
              <a
                key={product.id}
                href={product.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-4 px-6 py-4 rounded-2xl bg-[#1a1a1f] border border-white/5 hover:border-purple-500/30 transition-all duration-300 hover:scale-[1.02]"
              >
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-12 h-12 object-contain"
                />
                <span className="text-white font-medium">{product.name}</span>
                <ArrowUpRight className="w-4 h-4 text-gray-400 group-hover:text-white transition-colors" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SaasSection;
